export enum PositionStatus {
    EARNING = 0,
    UNLOCKING = 1,
    UNLOCKED = 2,
}
